import { useEffect } from 'react';
import { useRouter } from 'next/router';

export default function AdminIndex() {
  const router = useRouter();

  useEffect(() => {
    // Automatically redirect /admin to /admin/create-blog
    // The create-blog page will handle checking if the user needs to login
    router.replace('/admin/create-blog');
  }, [router]);

  return (
    <div style={{ backgroundColor: '#050505', minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#54b248' }}>
      <h2>Redirecting to Admin Dashboard...</h2>
    </div>
  );
}
